const linksEn = [
	{
		path: '/en/probono/',
		home: true,
	},
	{
		path: '/en/probono/',
		name: 'Pro Bono',
		active: true,
	},
];

export default linksEn;
